export function PageLoader() {
  return (
    <div className="flex items-center justify-center py-32" role="status" aria-label="Загрузка">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-indigo-600" />
    </div>
  )
}

export default PageLoader
